import {
	clearMatrixUpdate,
	setRiskSetupDirty,
	setSaveRun,
} from '@Actions/Risk.actions';
import { Grid } from '@mui/material';
import {
	selectIsRiskSetupDirty,
	selectRiskStore,
} from '@Selectors/Risk.selectors';
import React, { useEffect } from 'react';
import { setTab } from '@Actions';
import { useDispatch } from 'react-redux';
import { NavigationPrompt } from '@innovyze/stylovyze';
import { useHistory } from 'react-router-dom';
import { useGlobalization } from '@Translations/useGlobalization';
import { selectRiskRunning } from '@Selectors/util.selectors';
import { buildComponentTableCells } from './buildComponentTableCells';
import { ClassicRiskSetupBody } from './ClassicRiskSetupBody';
import { RiskGrade, RiskSetupAssetFilter } from '@Components';
import { useIsRiskTemplatesEnabled } from '@Hooks/useIsRiskTemplatesEnabled';
import { PreRunSummary } from './PreRunSummary.component';
import { RiskSetupIntro } from './RiskSetupIntro.component';

export const RiskSetup = () => {
	const { t } = useGlobalization();
	const dispatch = useDispatch();
	const history = useHistory();

	useEffect(() => {
		dispatch(setTab('risk'));
	}, []);

	const isRiskTemplatesEnabled = useIsRiskTemplatesEnabled();
	const riskStore = selectRiskStore();
	const isRiskRunning = selectRiskRunning();

	const isRiskSetupDirty = selectIsRiskSetupDirty();
	const assetFilter = riskStore.riskConfig?.assetFilter;
	const isBusy =
		riskStore.isLoading || riskStore.isPreviewLoading || isRiskRunning;
	const lofTableCells = riskStore.isLoading
		? []
		: buildComponentTableCells(riskStore.riskConfig.LOFCategories);
	const cofTableCells = riskStore.isLoading
		? []
		: buildComponentTableCells(riskStore.riskConfig.COFCategories);

	return (
		<Grid container spacing={3}>
			<NavigationPrompt
				when={isRiskSetupDirty}
				navigate={nextLocation => {
					history.push(nextLocation);
				}}
				onNavigateAway={() => dispatch(setSaveRun(true))}
				secondaryConfirmText={t('Discard')}
				shouldBlockNavigation={() => true}
				shouldBlockReload={isRiskSetupDirty}
				onSecondaryNavigateAway={() => {
					dispatch(clearMatrixUpdate(true));
					dispatch(setRiskSetupDirty(false));
				}}
				content={t(
					'You have modified your Risk model and have unsaved changes.  You can save changes, discard changes, or cancel to continue editing.',
				)}
				confirmText={t('Save')}></NavigationPrompt>
			{isRiskTemplatesEnabled ? (
				<Grid item xs={12} className={isBusy ? 'wait' : ''}>
					<RiskSetupIntro />
					<RiskGrade
						isLoading={isBusy}
						renderSummary={draft => (
							<PreRunSummary
								draft={draft}
								assetType={
									riskStore.riskConfig.riskSetting.assetType
								}
								assetFilterId={
									riskStore.riskConfig.riskSetting
										.assetFilterId
								}
								lofCategories={
									riskStore.riskConfig.LOFCategories
								}
								cofCategories={
									riskStore.riskConfig.COFCategories
								}
							/>
						)}
						belowContent={
							assetFilter && (
								<RiskSetupAssetFilter
									assetFilter={assetFilter}
								/>
							)
						}
					/>
				</Grid>
			) : (
				<ClassicRiskSetupBody
					isLoading={riskStore.isLoading}
					isBusy={isBusy}
					lofTableCells={lofTableCells}
					cofTableCells={cofTableCells}
					assetFilter={assetFilter}
				/>
			)}
		</Grid>
	);
};
